import AHDate from "_shared/dates/date";
import type { NameState } from "permissions/_views/targets/permission-target-state";
import { personReference } from "permissions/_views/targets/permission-target-state";
import { grantDate } from "permissions/_views/wording/permission-wording";

/**
 * Who made a template and when: "Made by Dana Ruiz, 12 Aug". A template belongs to its organization,
 * not to its maker (#6826), so this says only who made it; it grants that person nothing. A maker
 * who has left is still named as the directory names them, or as "a former member". While the
 * directory has not answered, or failed to, the line says only when: "Made 12 Aug".
 */
export function madeBy(maker: NameState, date: AHDate | undefined, today: AHDate): string {
  const when = date ? grantDate(date, today) : undefined;
  if (maker.state === "loading" || maker.state === "failed") return when ? `Made ${when}` : "";
  const who = `Made by ${personReference(maker)}`;
  return when ? `${who}, ${when}` : who;
}
